import './style.scss';
import { tns } from 'tiny-slider/src/tiny-slider';

if (document.querySelector('.slider-root')) {
  const slider = tns({
    container: '.slider-root',
    items: 1,
    arrowKeys: true,
    swipeAngle: false,
    controls: false,
    speed: 400,
    gutter: 24,
    responsive: {
      480: {
        items: 1,
      },

      768: {
        items: 2,
      },
    },
  });

  const prev = document.querySelector('.slider-control .slider-control__prev');
  const next = document.querySelector('.slider-control .slider-control__next');

  prev.addEventListener('click', () => {
    slider.goTo('prev');
  });

  next.addEventListener('click', () => {
    slider.goTo('next');
  });
}
